<template>
    <div class="list">
        <Header ref="header" :title="title" @backPage="onBackPage"></Header>
        <div class="container">
            <div v-if="enquiryList.length">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    :finished-text="finishText"
                    :immediate-check="false"
                    @load="onLoad"
                >
                    <div class="content" v-for="item in enquiryList" :key="item.id" @click="handleDetail(item.id)">
                        <div class="head">询价单编号: {{ item.inquiryNo }}
                            <span :class="{
                                'staryStatus': item.inquiryStatus === 10,
                                'handStatus': item.inquiryStatus === 20 || item.inquiryStatus === 30,
                                'successStatus': item.inquiryStatus === 40 || item.inquiryStatus === 50,
                                'loseStatus': item.inquiryStatus === 60 || item.inquiryStatus === 70}
                            ">{{ enquiryStatus(item.inquiryStatus) }}</span></div>
                        <div class="cont">
                            <div class="img"><img :src="item.brandLogo" alt=""></div>
                            <div class="info">
                                <div class="title">{{ messageHtml(item.requiredProductDescription) }}</div>
                                <p>数量：{{ item.inquiryCount }}</p>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
            <div v-else>
                <Empty />
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../../common/header'
import Empty from './component/empty'
import { getEnquiryList } from '../api/api'
export default {
    name: 'enquiryList',
    components: {
        Header,
        Empty
    },
    data () {
        return {
            title: '询价单列表',
            userInfo: '',
            enquiryList: [],
            pageNumber: 1,
            pageSize: 10,
            finishText: '数据已加载完毕',
            loading: false,
            finished: false
        }
    },
    methods: {
        onBackPage () {
            this.$router.push({ path: '/b2b/order/index' })
        },
        enquiryStatus (key) {
            switch (key) {
                case 10:
                    return '待处理'
                case 20:
                    return '处理中'
                case 30:
                    return '处理中'
                case 40:
                    return '已完成'
                case 50:
                    return '已完成'
                case 60:
                    return '已关闭'
                case 70:
                    return '已关闭'
                default:
                    break
            }
        },
        handleDetail (id) {
            this.$router.push({ path: '/b2b/inquiry/inquiryDetail', query: { id: id } })
        },
        onLoad () {
            this.pageNumber += 1
            this.initPage()
        },
        messageHtml (val) {
            return val.replace(/[\r\n]/g, '')
        },
        async initPage () {
            const { data } = await getEnquiryList({
                memberCode: this.userInfo.companyCode,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            })
            if (!data.records.length) {
                return false
            }
            this.enquiryList = this.enquiryList.concat(data.records)
            this.loading = false
            if (this.enquiryList.length >= data.total) {
                this.finished = true
            }
            if (data.total < this.pageSize) {
                this.finishText = ''
            }
        }
    },
    created () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.initPage()
    }
}
</script>

<style lang="scss" scoped>
    .container {
        padding: 0 16px;
        .content {
            background: #ffffff;
            margin-top: 20px;
            border-radius: 8px;
            .head {
                display: flex;
                justify-content: space-between;
                font-size: 26px;
                color: #333333;
                padding: 16px;
                border-bottom: 1px solid #EDEDF0;
                .staryStatus {
                    color: #FF4D4D;
                }
                .handStatus {
                    color: #FFA940;
                }
                .successStatus {
                    color: #3399FF;
                }
                .loseStatus {
                    color: #999999;
                }
            }
            .cont {
                padding: 24px 16px;
                display: flex;
                justify-content: flex-start;
                font-size: 28px;
                .img{
                    flex: 0 0 140px;
                    width: 140px;
                    height: 140px;
                    margin-right: 26px;
                    border: 1px solid #EDEDF0;
                    padding: 0 12px;
                    border-radius: 8px;
                    display: flex;
                    box-sizing: border-box;
                    img{
                        align-self: center;
                        justify-self: center;
                        margin: 0 auto;
                    }
                }
                .info {
                    color: #000000;
                    line-height: 40px;
                    padding-top: 32px;
                    .title{
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 1;
                        overflow: hidden;
                        white-space: normal;
                        word-break: break-all;
                    }
                }
            }
        }
    }
</style>